export default __webpack_public_path__ + "static/media/fa-solid-900.07c3313b.ttf";